export default function About() {
    return (
      <div className="text-white p-10">
        <h1 className="text-3xl font-bold">About Page</h1>
      </div>
    )
  }
  